<template>
    <section class="gridClass my-8">
        <div class="py-10 border-t border-b relative border-[#1166FB] flex flex-col lg:flex-row justify-between items-center">
            <div class="absolute flex justify-center items-center mb-10 w-full -top-5">
                <span class="text-2xl font-bold px-5 bg-white text-[#1166FB]"> {{ details.title }}</span>
            </div>
            <MetamaApp class="mt-2" :data="item" v-for="item in details.items" :key="item.id" />
        </div>
    </section>
</template>

<script setup>
defineProps({
    details: Object
})
</script>